const colors = {
    primary: "#1E1517",
    secondary: "#496C99",
    white: "#FFFFFF",
    green: "#2FEA52",
    gray4: '#BDBDBD',
    gray8: '#E5E5E5',
    input: '#F0F9FD',
    separator: '#DEDEDE',
    textSecondary: '#9495A9',
    textPrimary: '#323352',
    brand: {
        50: '#F8ECEF',
        100: '#F5E4E9',
        200: '#EBCBD4',
        300: '#C98A9A',
        400: '#9C3A52',
        500: '#7A1F35', // główny zielony
        600: '#5C1628',
        700: '#3A0F1B', // ciemna zieleń (stopka, sekcje)
        800: '#2C0B14',
        900: '#1F070E',
    },
    // nowy design: neutralne tła i tekst
    surface: {
        page: '#F8F5F4',
        card: '#FFFFFF',
        muted: '#F3ECEC',
        border: '#ECE4E4',
        control: '#DED3D4',
    },
    ink: {
        900: '#1E1517',
        700: '#3B3033',
        600: '#4B3F42',
        500: '#6E6064',
    },
    lime: '#F4B8C5',
}

export default colors;
